<script setup>
import CompanyHeader from './CompaniesHeader/CompanyHeader.vue';
import PaginationFooter from 'dashboard/components-next/pagination/PaginationFooter.vue';

// Same shell as Contactos / Tareas: one white card on the grey canvas
// holding header, table and pagination.
defineProps({
  searchValue: { type: String, default: '' },
  headerTitle: { type: String, default: '' },
  currentPage: { type: Number, default: 1 },
  totalItems: { type: Number, default: 0 },
  activeSort: { type: String, default: 'name' },
  activeOrdering: { type: String, default: '' },
  showPaginationFooter: { type: Boolean, default: true },
});

const emit = defineEmits(['update:currentPage', 'update:sort', 'search', 'add']);
</script>

<template>
  <section class="flex w-full h-full p-3 overflow-hidden bg-n-background">
    <div
      class="flex flex-col w-full h-full rounded-2xl border border-n-container bg-n-solid-2 overflow-hidden"
    >
      <CompanyHeader
        :search-value="searchValue"
        :header-title="headerTitle"
        :total-count="totalItems"
        :active-sort="activeSort"
        :active-ordering="activeOrdering"
        @search="emit('search', $event)"
        @update:sort="emit('update:sort', $event)"
        @add="emit('add')"
      />
      <main class="flex-1 overflow-y-auto min-h-0">
        <div class="w-full">
          <slot name="default" />
        </div>
      </main>
      <footer
        v-if="showPaginationFooter"
        class="sticky bottom-0 z-0 px-4 pb-4 border-t border-n-weak bg-n-solid-2"
      >
        <PaginationFooter
          current-page-info="COMPANIES_LAYOUT.PAGINATION_FOOTER.SHOWING"
          :current-page="currentPage"
          :total-items="totalItems"
          :items-per-page="25"
          @update:current-page="emit('update:currentPage', $event)"
        />
      </footer>
    </div>
  </section>
</template>
